module.exports = __webpack_public_path__ + "64bba9c4e8156c152050c657e9d24bf1.woff";